var _path, _rect, _path2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 421 287",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 20.736,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 221V19C50 17 52 15 54 15H367C369 15 371 17 371 19V221"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 40,
    width: 270,
    height: 156,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211 40V196M76 118H346",
    strokeLinecap: "butt"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 79,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 79,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 157,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 157,
    r: 18
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 221H396V229C396 249 380 265 360 265H61C41 265 25 249 25 229V221ZM154 222V239C154 241 156 242 159 242H262C265 242 267 241 267 239V222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.3b3c6b5981192e9b0cd659f22fbd2f58.svg";
export { ForwardRef as ReactComponent };